import React from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import Paper from '@material-ui/core/Paper'
import { fade, makeStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Button, CircularProgress }  from '@material-ui/core';
import moment from 'moment';
import TextField from '@material-ui/core/TextField';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import EditRoundedIcon from '@material-ui/icons/EditRounded';
// import DialogContentText from '@material-ui/core/DialogContentText';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Switch from '@material-ui/core/Switch';
// import Tooltip from '@material-ui/core/Tooltip';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
// import styles from './customer.module.scss'
import SuppliesUsedModal from './SuppliesUsedModal'
import TakeOffsUsedModal from './TakeOffsUsedModal'

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const filter = createFilterOptions();
const OPTIONS_LIMIT = 5

const filterOptions = (options, state) => {
  return filter(options, state).slice(0, OPTIONS_LIMIT);
};

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    margin: '20px',
    zIndex: 8
  },
  paper: {
    width: '100%',
    minWidth: '500px',
    marginBottom: theme.spacing(2),
  },
  grid: {
    margin: '10px',
    padding: '10px',
    width: '95%'
  },
  gridParent: {
    margin: '10px',
    padding: '10px',
    width: '95%',
    border: '3px solid #aaa',
    borderRadius: '20px'
  },
  gridItem: {
    padding: '5px'
  },
  table: {
    minWidth: 750,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paymentProfiles: {
    border: '1px solid',
    // marginRight: '5px',
    // padding: '5px'
  },
  bigText: {
    fontSize: '1.5em',
    color: '#333',
    textAlign: 'center'
  },
  paddedStuff: {
    padding: '5px',
    margin: '5px'
  }
}));

const defaultValues = {
  onSite: null,
  offSite: null,
  hoursWorked: 0,
  travelTime: 0,
  notes: '',
  servicesPerformed: [],
  workorder: {},
  chargeForExtras: false
}

const HoursWorkedModal = (props) => {
  // console.log('HoursWorkedModal  Props: ', props)
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false)
  const [state, setState] = React.useState(defaultValues)
  const [clientList, setClientList] = React.useState([])
  const [client, setClient] = React.useState({})
  const [crew, setCrew] = React.useState({})
  const [crews, setCrews] = React.useState([])
  const [employees, setEmployees] = React.useState([])
  const [servicesPerformed, setServicesPerformed] = React.useState([])
  const [suppliesUsed, setSuppliesUsed] = React.useState([])
  const [showSuppliesUsedModal, setShowSuppliesUsedModal] = React.useState(false)
  const [clientWorkorders, setClientWorkorders] = React.useState([{serviceName: '', jobName: '', jobNumber: ''}])
  const [workorder, setWorkorder] = React.useState({})
  const [mtcAgreements, setMtcAgreements] = React.useState([])
  const [isFlatRate, setIsFlatRate] = React.useState(false)
  // const [state, setState] = React.useState({
  //   counter: 0
  // })
  const serviceRef = React.useRef(null)
  // let isFlatRate = false
  React.useEffect(() => {
    let isMounted = true
    // const fetchClients = async () => {
    //   setLoading(true)
    //   axios.get(`${props.url}/api/customer/clients`).then((response, status, data) => {
    //     setLoading(false)
    //     if (response && response.data) {
    //       if (isMounted) setClientList(response.data)
    //     }
    //   })
    // }
    // fetchClients()
    setClientList(props.clients)
    setCrews(props.crews)
    return () => {
      isMounted = false
    }
  }, [props])

  React.useEffect(() => {
  // console.log('Client Changed - get workorders for ', client)
    let isMounted = true

    async function fetchWos(id) {
    // console.log('Get id:', id)
      setLoading(true)
      axios.get(`${props.url}/api/jobs/getClientWorkorders?id=${id}`).then((response, status, data) => {
        setLoading(false)
        if (response && response.data) {
        // console.log('Res', response.data)
          if (isMounted) {
            setClientWorkorders(response.data)
          }
        }
      })
  }
  async function fetchMtcAgreement(id) {
  // console.log('Get Mtc Agreement:', id)
    setLoading(true)
    axios.get(`${props.url}/api/customer/getMtcAgreements?id=${id}`).then((response, status, data) => {
      setLoading(false)
      if (response && response.data) {
      // console.log('Res', response.data)
        if (isMounted) {
          setMtcAgreements(response.data)
          // isFlatRate
          let flatRate = false
          // setClientList(response.data)
          response.data.map(item => {
           if (item.servicePlan === 'FRP') flatRate = true
          })
          setIsFlatRate(flatRate)
        }
      }
    })

  }

    if (client && client._id) {
      // fetchWos(client._id)
      fetchMtcAgreement(client._id)
    }
    return () => {
      isMounted = false
    }
  }, [client])
const handleClose = () => {
// console.log('Closing DepositModal Modal')
  props.closeModal()
}

const handleTimeChange = (type, value) => {
// console.log('Type: ', type)
  let isValid = moment(value, 'YYYY-MM-DDThh:mm').isValid()
// console.log('Valid? ', isValid)
  if (isValid) {
  // console.log('Value: ', value)
    let onSite = null
    let offSite = null
    if (type === 'onSite') {
      onSite =  moment(value, 'YYYY-MM-DDThh:mm').local()
      // offSite = moment(value, 'YYYY-MM-DDThh:mm').add(1, 'hours').local()
      if (state.offSite) {
        offSite = state.offSite // moment(state.offSite, 'YYYY-MM-DDThh:mm').local()
      } else {
        offSite = moment(value, 'YYYY-MM-DDThh:mm').add(1, 'hours').local()
      }

    }
    if (type === 'offSite') {
      onSite = moment(state.onSite, 'YYYY-MM-DDThh:mm').local()
      offSite = moment(value, 'YYYY-MM-DDThh:mm').local()
    }
  // console.log('onSite IN', onSite)
  // console.log('offSite out: ', offSite)
    let hoursWorked = Math.abs(onSite - offSite) / 36e5
  // console.log('Hours WOrked: ', hoursWorked)
    hoursWorked = parseFloat(hoursWorked).toFixed(2)
  // console.log(hoursWorked)
    // if (clockOut < clockIn && state.weWantThis) {
    //   if (window.confirm('Your Clock-Out Time Is Before the Clock-In Time...Should We Reverse Them?')) {
    //   // console.log('Reverse em!')
    //     setState({...state, clockIn: clockOut, clockOut: clockIn, hoursWorked: hoursWorked})
    //     props.notification({
    //       type: 'warning',
    //       title: `Uh Oh - That Doesn't Seem Right!`,
    //       message: 'Your Clock-In Time Was After The Clock-Out - So We Reversed Them!'
    //     })
    //   } else {
    //     setState({...state, clockIn: clockIn, clockOut: clockOut, hoursWorked: 0})
    //   }
    // } else {
      setState({...state, onSite: onSite, offSite: offSite, hoursWorked: hoursWorked})
    // }
  }
}

const updateCustomer = (e, customer) => {
  if (customer && customer._id) {
    setClient(customer)
  }
}

const updateWorkorder = (e, wo) => {
// console.log('update workorder:', wo)
  if (wo && wo._id) {
    setWorkorder(wo)
    setState({...state, workorder: wo})
  }
}
const updateCrew = (e, crew) => {
  if (crew && crew._id) {
    setCrew(crew)
  }
}

const updateEmployees = (e, emps) => {
  if (emps) {
    setEmployees(emps)
  }
}

const handleTabInteraction = (e) => {
  if (e.keyCode == 9) {
  // console.log(e.target)
    if (e.target.id === 'customername') {
      // window.alert(`Tab on custoemr ${e.target.value}`)
      let newArr = []
      let string = e.target.value
      props.clients.filter(o => {
        let str = o['displayName'].toString().toLowerCase()
        if (str.includes(string.toLowerCase())) {
          return newArr.push(o)
        } else {
          return null
        }
      })
      // console.log(newArr)
      if (newArr && newArr.length) {
        setClient(newArr[0])
      }
    }
    if (e.target.id === 'crewlistautocomplete') {
      let newArr = []
      let string = e.target.value
      props.crews.filter(o => {
        let str = o['name'].toString().toLowerCase()
        if (str.includes(string.toLowerCase())) {
          return newArr.push(o)
        } else {
          return null
        }
      })
      // console.log(newArr)
      if (newArr && newArr.length) {
        setCrew(newArr[0])
      }
    }
  }
}

const handleFocus = (event) => event.target.select();

const handleSave = async () => {
  // console.log('Save this shit')
  let obj = {
    state,
    client,
    crew,
    employees,
    suppliesUsed
  }
  setLoading(true)
  const response = await axios.post(`${props.url}/api/customer/bhlHoursWorked`, obj)
  // console.log('Paid Bulk Invoices!!', response)
  setLoading(false)
  if (response && response.data) {
    setState(defaultValues)
    setClient({})
    setCrew({})
    setServicesPerformed([])
    handleClose()
    props.notification({
      type: 'success',
      title: 'Added Service Notes & Hours Worked',
      message: 'We Have Saved That Data!!'
    })
    // serviceRef.current.value = null
  }
}

const servicesList = ["Trim & Mow Lawn","Detail","Rake","Water Pots","General Clean Up","Pull Weeds","Trim Trees","Trim Plants","Check Clock","Wash Patios","Fertilize Lawn","Yard","Paperwork","Check Clocks","Remove Christmas Debris","General Clean Up At Vasoloupolis***","Check Lights","Spray Pet Area","Repair Irrigation","Check Irrigation","Dead Head Flowers","Repair Entry Gate At Motor Court***Welding Flat Rate????","Weld Back Gate Hinge","Meet With Bull Frog","Adjust Hinge Rear Gate","Cut Off Lock Pool Fence","Spray Weeds","Fertilize Roses","Check Spray Heads","Tie Vines To Wall","Spray Insecticide","Spray Simple Green","Replace Two Valves","Turn Clock On","Fertilize","Meet Tree Doctors At Powell**","Check Lights And Replace Bulbs As Needed","Check Lights And Replace Bulb As Needed","Clean Front Of Drain Pipe","Deatil","Work With Well Guys: Bloomquist Pump Service","Plant New Plants","Replace Valve","Staked Trees","Check Irrigation And Valve Boxes","Cut Up Ironwood Tree And Limbs From Storm Damage","Spray Thuricide","Work On Main Line Leak","Reset Lighting In Pool Area","Remove Broken Branch","Check Lights And Repair As Needed","Check Gfi On Tree Lights","Fix Son'S Light","Check Lights And Replace As Needed","Attach Anchors","Clean And Chlorinate Water Feature","Start Up","Transplant Cactus","Treat Rodents","Replave Valve","Work At Yard","Gopher Control","Fix Stuck Valve In Back Yard","Repair Irrigation At Bill Snyder***","Trim Roses","Staple Cables On Trees","Pull Dead Vines And Clean Area That Had Been Locked","Fertilize Cactus","Repair Lights","Stake Hop Bush","Sp y Weeds","Check Lawn And Adjust Clock As Needed","Repair Float Valve In Fountain","Pick Up Tree Branch","Repair Irrigation At Snyder**","Spread Sand","Make Plant List For Saturday","Repair Irrigation At John Pickett**","Storm Clean Up At Yard","Fertilize Plants","Repair Valve With On Site Materials","Find House Mainline Leak And Advise Caretaker","Check Sprinkler","Pick Plants At Nursery","Yard Paperwork","Cut Arm Off Totem Pole","Pick Up Granite For Tuesday","Repair Light","Pick Up Plants","Install Granite","Plant New Plants Supplied By Homeowner","Install Metal Edge","Plant New Plants (10) Supplied By Homeowner","Special Clean Up After Wind Storm","Remove Large Tree Limb Down From Wind","Transplant Prickly Pear At Road Side","Check Orchid","Check Pavers","Fertilize Flowers","Repair Irrigation Leak","Fertilize Plants`","Pick Out Sod","Install Sod","Pull 3 Oleanders At End Of Drive As Requested","Check Tree","Rake Along Old Train Tracks","Clean Up 1/2 Fallen Saguaro At Enty","Plant New Plants Provided By Homeowner","Trim Vines On Wall","Level Grass Areas With Sand","Remove Fallen Saguaro","Clean Out Water Feature","Put In New Filter Basket","Get It Running Again","Treat Texas Ebonys Along Drive","`","Fertilize Citrus","Find Leak And Talk With Nancy","Fertilize Bougainvilleas Along Office Wall","Clean Weeds From Planters Along Roses","Move Cactus Around In Desert As Requested","Restart River Feature","Clean Out Water Filter Line","Check Tree Trimming","Lock Back Gate","","Ferilize Lawn","Ferilize","Change Out Entry Transformer","Check Trees","Trim Tree Branch From Elm","Check Clock And Adjust Times As Needed","Plant New Plant At Entry","Spray Spray Pet Area","Trim Citrus","Check Trimmed Rosemary","Purchase Plants For Friday Planting","Check Grass And Adjust Clock As Needed","Pull Bougainvilleas Off Wall","Power Wash Patios","Plant New Plants In Front Pots","Use Wooden Planks To Supprt Saguaro","Shut Down Water Feature River For Summer","Check Painters","Check Bougainvilleas Off The Wall","Pull Cables From Trimmed Trees","Pick Plants And Flowers For Planting","Layout For Crew","Plant Flowers","Shut Down Clock For Nutgrass Treatment Monday","Check Artificial Grass","Check Lights And Replace Existing With New Led","Wire Bougainvilleas To Wall After Painting","Troubleshoot Clock And Wiring","Valves","Repaair Leaking Pot","Check New Plantings","Re-Do Pot With Mircro Tubing","Put Pot Together After ReSealing","Wash Patios And Walls","Blow Backyard As Requested","Plant Flowers From Homeowner","Detail Backyard By Pool","Blow All Areas And Rake Drive","Wire Bougainvillea Back On Wall After Paint","Take Down Balance Of Elm Tree Cables","Remove 2 Sago Palms In Back Yard","Check Bougainvilleas","Install New Poly Line In Front Planter","No Power To Clocks","Fix Leak At Pool House Pots","Put Volleyball Net Back Up","Fertilize Bougainvilleas South Side Of Office","Pull Winter Flowers","Take Out Plants As Requested","Change Palm Crew","Layout Plants From Owner For Install Crew","Set Up Palm Crew","Shut Water Off To Grass To Prep For Artificial Turf","Check Sour Orange","Fill In Planter At Guesthouse After Plumber Repair Work","Remove Flowers","Check Palm Tree Trimming","Lay Out And Plants Flowers","Get Flowers","Layout","Prep Flower Beds","And Plant Flowers","Run Micro Tubing In Planters","General Clean Up With Install Crew","Put Cushions Away For Summer","Remove Plants In Back","Run Irrigation To Flowers","x","Repair Irrigation Leak Under Drive In Sleeve","Walk Property With House Manager","Troubleshoot Hammer Noise In Pipes","Trim And Mow Lawn","Check Broken Window","Check Gate","Check Flowerbed For Leak","None Found","Adjust Clock","Turn Off Clock For Nutgrass Spraying","Trim & Moaw Lawn","Power Rake Lawn","Staked Tree","Take Out Cactus","Remove Agave Out Of Driveway {Storm Clean Up}","Find Mainline House Leak","Tie Bougainvilleas Back On Garage","Cut Up Broken Tree Limbs","Stake Ocotillo","Set Transformer","Reset Wire Around Agave","Remove Debris","Check Leak In Fert Tank","Remove (2) Large Ocotillio","Put Out Putting Green In Backyard","Find Leak At Meter Call For Plumber Repair","Clean All Trash Off Of Roof","Blow Off Roof AS and JN Install Bill Install?","Check Broken Tree Limb","Check Grass","Repair Leaks","Repair Irrigation Under Artifical Turf","Check Clock Replace And Reprogram As Needed","#VALUE!","Leak At Drive","Shade Plants","Blow Pots And Driveway","Cover Plants"]

const handleUpdateServices = (e, service) => {
// console.log('E: ', e)
// console.log('Updat eService: ', service)
  let svc = service[service.length - 1]
  if (svc && svc.inputValue) {
    let serviceList = service
  // console.log('Service LIst: ', serviceList)
  // console.log('NEW SERVICE', svc)
    service[serviceList.length - 1] = svc.inputValue
  // console.log(e.target.value)
  // console.log('SET SERVICES:', serviceList)
    setServicesPerformed(serviceList)
    setState({...state, servicesPerformed: serviceList })

  } else {
  // console.log(e.target.value)
  // console.log(service)
    setServicesPerformed(service)
    setState({...state, servicesPerformed: service })
  }  
}

const handleSuppliesUsedModal = () => {
  setShowSuppliesUsedModal(true)
}

const handleUpdateSuppliesUsed = (d) => {
// console.log('Update our supply list:', d)
  setSuppliesUsed(d)
}

const handleChangeChargeForExtras = (e) => {
  setState({...state, chargeForExtras: !state.chargeForExtras })
}

return (
  <div className={classes.root}>
    
    <Dialog className={classes.paper} open={props.open} fullWidth={true} maxWidth='md' aria-labelledby="form-dialog-title">
      {/* <SuppliesUsedModal open={showSuppliesUsedModal} client={client} crew={crew} supplies={props.supplies} closeModal={e => setShowSuppliesUsedModal(false)} /> */}
        <DialogTitle id="form-dialog-title">Add Hours Worked & Services Performed</DialogTitle>
        <DialogContent >
          <DialogContentText>
            Please Provide Information Below
          </DialogContentText>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={12}>
              <Autocomplete
                id={`customername`}
                options={props.clients || []}
                getOptionLabel={(option) => {
                  // console.log('Options: ', option)
                  return (option && option._id) ? `${option.displayName || ''} (${option.agId || ''}) ` : ''
                }}
                // style={{ width: 200 }}
                style={{marginBottom: '20px'}}
                onChange={updateCustomer}
                disabled={loading}
                // onChange={ (e) => updateCrew(service, e.target.id, e.target.value, serviceIndex) }
                value = {client}
                // onChange={ e => setState({...state, serviceType: e.target.value, requiresUpdate: true }) }
                renderInput={(params) => <TextField {...params} label="Customer" onKeyDown={handleTabInteraction} variant="outlined" />}
              />
            </Grid>
            {isFlatRate ? (
              <Grid item xs={12} lg={12}>
                {/* {isFlatRate ? ( */}
                  Charge For Extras: <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={state.chargeForExtras}
                    onChange={handleChangeChargeForExtras}
                />
                 </Grid>
                ) : null}
           
            {/* <Grid item xs={12} lg={12}>
              <Autocomplete
                id={`workorder`}
                options={clientWorkorders || []}
                getOptionLabel={(option) => {
                  // console.log('Options: ', option)
                  return `${option.serviceName ? option.serviceName : ''} - ${option.jobName ? option.jobName : '' } - ${option.jobNumber ? option.jobNumber : ''}` || ''
                }}
                // style={{ width: 200 }}
                style={{marginBottom: '20px'}}
                onChange={updateWorkorder}
                disabled={loading}
                // onChange={ (e) => updateCrew(service, e.target.id, e.target.value, serviceIndex) }
                value = {workorder}
                // onChange={ e => setState({...state, serviceType: e.target.value, requiresUpdate: true }) }
                renderInput={(params) => <TextField {...params} label="Workorder" onKeyDown={handleTabInteraction} variant="outlined" />}
              />
            </Grid> */}
            <Grid item xs={12} lg={12}>
              <Autocomplete
                multiple
                id={`employeelistautocomplete`}
                options={props.employees || []}
                getOptionLabel={(option) => {
                  // console.log('Options: ', option)
                  return option.displayName || ''
                }}
                disableCloseOnSelect
                // style={{ width: 200 }}
                style={{marginBottom: '20px'}}
                onChange={updateEmployees}
                disabled={loading}
                // onChange={ (e) => updateCrew(service, e.target.id, e.target.value, serviceIndex) }
                value = {employees}
                renderOption={(option, { selected }) => {
                 
                    return (
                  <React.Fragment>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option.displayName}
                  </React.Fragment>
                    )
                  
                }}
                // onChange={ e => setState({...state, serviceType: e.target.value, requiresUpdate: true }) }
                renderInput={(params) => <TextField {...params} label="Employee" onKeyDown={handleTabInteraction} variant="outlined" />}
              />
            </Grid>
            {/* <Grid item xs={12} lg={12}>
              <Autocomplete
                id={`crewlistautocomplete`}
                options={props.crews || []}
                getOptionLabel={(option) => {
                  // console.log('Options: ', option)
                  return option.name || ''
                }}
                // style={{ width: 200 }}
                style={{marginBottom: '20px'}}
                onChange={updateCrew}
                disabled={loading}
                // onChange={ (e) => updateCrew(service, e.target.id, e.target.value, serviceIndex) }
                value = {crew}
                // onChange={ e => setState({...state, serviceType: e.target.value, requiresUpdate: true }) }
                renderInput={(params) => <TextField {...params} label="Crew" onKeyDown={handleTabInteraction} variant="outlined" />}
              />
            </Grid> */}
          </Grid>
          {/* { (crew && crew._id && client._id) ? ( */}
          <Grid container spacing={2}>
            <Grid item xs={12} lg={6}>
            <TextField
              id="date"
              label="On-Site"
              type="datetime-local"
              value={moment(state.onSite).format('YYYY-MM-DDTHH:mm') } // "2017-05-24"}
              // className={classes.textField}
              variant="outlined"
              onChange={e => handleTimeChange('onSite', e.target.value)}
              // onChange={e => setState({...state, clockIn: e.target.value })}
              // onChange={ e => handleServiceChange(state.workorder, 'scheduledDate', e.target.value, state.serviceIndex) }
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              style={{marginBottom: '20px'}}
            />
            </Grid> 
            <Grid item xs={12} lg={6}>
           <TextField
              id="date"
              label="Off-Site"
              type="datetime-local"
              fullWidth
              value={moment(state.offSite).format('YYYY-MM-DDTHH:mm') } // "2017-05-24"}
              // className={classes.textField}
              variant="outlined"
              // onChange={e => setState({...state, clockOut: e.target.value })}
              onChange={e => handleTimeChange('offSite', e.target.value)}
              // onChange={ e => handleServiceChange(state.workorder, 'scheduledDate', e.target.value, state.serviceIndex) }
              InputLabelProps={{
                shrink: true,
              }}
              style={{marginBottom: '20px'}}
            />
            </Grid>
            <Grid item xs={12} lg={6}>
            <TextField
              id="hoursWorked"
              label="Hours Worked"
              type="text"
              disabled
              value={state.hoursWorked } // "2017-05-24"}
              // className={classes.textField}
              variant="outlined"
              // onChange={e => setState({...state, hoursWorked: e.target.value })}
              // onChange={ e => handleServiceChange(state.workorder, 'scheduledDate', e.target.value, state.serviceIndex) }
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              style={{marginBottom: '20px'}}
            />
            </Grid>
            <Grid item xs={12} lg={6}>
            {/* <TextField
              id="hoursWorked"
              label="Travel Time (Minutes)"
              type="text"
              value={state.travelTime } // "2017-05-24"}
              // className={classes.textField}
              variant="outlined"
              onFocus={handleFocus}
              onChange={e => setState({...state, travelTime: e.target.value })}
              // onChange={ e => handleServiceChange(state.workorder, 'scheduledDate', e.target.value, state.serviceIndex) }
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              style={{marginBottom: '20px'}}
            /> */}
             </Grid>
            <Grid item xs={12} lg={12}>
            <Autocomplete
              freeSolo
              multiple
              id="servicesperformed"
              fullWidth
              value={servicesPerformed}
              options={servicesList}
              onChange={handleUpdateServices}
              disableCloseOnSelect
              getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                  return option;
                }
                // Add "xxx" option created dynamically
                if (option.inputValue) {
                  return 'Save ' + option.inputValue + ' as a New Item';
                }
                // Regular option
                return option
              }}
              renderOption={(option, { selected }) => {
                // // console.log('OPTIONS: ', option)
                if (option.inputValue) {
                  return (
                    <React.Fragment>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {`Add ${option.inputValue} as a New Service`}
                </React.Fragment>
                  )
                } else {
                  return (
                <React.Fragment>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option}
                </React.Fragment>
                  )
                }
              }}
              // filterOptions={filterOptions}
              filterOptions={(options, params) => {
                // // console.log('Filtered Options', options)
                // // console.log('Params', params)
                // // console.log('Input value: ', params.inputValue)
                const filtered = filter(options, params);
        
                // Suggest the creation of a new value
                if (params.inputValue !== '') {
                  filtered.push({
                    inputValue: params.inputValue,
                    title: `Add "${params.inputValue}"`,
                    name: 'Add New Supplier'
                  });
                }
        
                return filtered;
              }}

              renderInput={(params) => (
                <TextField {...params} style={{marginBottom: '20px'}} variant="outlined" label="Service(s) Performed" placeholder="Which Services Were Performed?" />
              )}
            />
            </Grid>
            <Grid item xs={12} lg={12}>
              <SuppliesUsedModal client={client} crew={crew} supplies={props.supplies} updateSupplyList={handleUpdateSuppliesUsed} />
              {/* <Button disabled={!client.displayName || !crew._id} fullWidth variant="contained" color="secondary" style={{marginBottom: '20px'}} onClick={handleSuppliesUsedModal}>Add Supplies Used</Button> */}
            </Grid>
            <Grid item xs={12} lg={12}>
              <TakeOffsUsedModal client={client} crew={crew} supplies={props.takeoffs} updateSupplyList={handleUpdateSuppliesUsed} />
              {/* <Button disabled={!client.displayName || !crew._id} fullWidth variant="contained" color="secondary" style={{marginBottom: '20px'}} onClick={handleSuppliesUsedModal}>Add Supplies Used</Button> */}
            </Grid>
            <Grid item xs={12} lg={12}>
            <TextField
                id="notes"
                label="Notes"
                multiline
                rows={3}
                variant="outlined"
                fullWidth
                // className={classes.textSaveLineBreaks}
                value={state.notes}
                onChange={e => setState({...state, notes: e.target.value})}
                // onChange={ e => handleServiceChange(state.workorder, 'serviceDescription', e.target.value, state.serviceIndex) }
                // defaultValue="Default Value"
            />
            </Grid>

                
          </Grid>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button color="primary" onClick={handleSave} disabled={!employees || !client._id || !state.hoursWorked || !state.onSite || !state.offSite}>
            {
              loading ? <CircularProgress /> : 'Save'
            }
          </Button>
        </DialogActions>
      </Dialog>
  </div>
  )
  }


  const mapStateToProps = (state) => {
    return {
      url: state.url,
      user: state.user,
      notification: state.notification,
      employees: state.employees
    }
  }
  
  export default React.memo(connect(mapStateToProps)(HoursWorkedModal))